import { Rastreio } from './enum';

export class EtapaRastreio {
  id: number;
  nome: string;
  enumInterno: Rastreio;
  ativo: number;
  ordem: number;
  icone: string;
  status: string;
}
